import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'date-time',
  template: `
    <div class="input-group mb-3 date-picker-custom">
  
    <input type="text" 
    [formControl]="formControl" 
    placeholder="dd-MMM-yy" 
    class="form-control calendar" 
    [formlyAttributes]="field" 
    [class.is-invalid]="showError" 
    [class.readonly-date]="true" 
    [bsConfig]="bsConfig"
    bsDatepicker 
    [readonly]="false" 
    #d="bsDatepicker">

    <button  class="input-group-append align-items-center bg-transparent rmv-btn" [disabled]="d.isDisabled" (click)="clear(d)">
      <img src="design/images/close-dark.png" class="ml-1 me-2 dark" style="width: 10px;height:10px" alt="remove">
      <img src="design/images/close-light.png" class="ml-1 me-2 light" style="width: 10px;height:10px" alt="remove">
    </button>
    
    <div class="input-group-append" (click)="d.toggle()" [attr.aria-expanded]="d.isOpen">
      <img src="design/images/calendar.png"/>
    </div>

  </div>`,
})

export class DateTime extends FieldType {

  bsConfig: Partial<BsDatepickerConfig> = {
    dateInputFormat: 'DD-MMM-YY HH:mm',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    customTodayClass: 'custom-today-class',
    adaptivePosition: true
  };

  clear(d) {
    d.bsValue = null;
  }

}
